package uz.ferro.erp.feature.order.model

enum class OrderStatus {
    NEW,
    PENDING_MANUAL,
    RESERVE_PENDING,
    RESERVED,
    RESERVE_FAILED,
    PAYMENT_PENDING,
    PAYMENT_SUCCESS,
    PAYMENT_FAILED,
    COMPLETE_PENDING,
    COMPLETED,
    COMPLETE_FAILED,
    REJECTED,
    CANCELLED,
    UNKNOWN;

    companion object {
        fun fromString(name: String): OrderStatus {
            return OrderStatus.entries.firstOrNull { it.name == name } ?: UNKNOWN
        }
    }
}